<script>
import {defineComponent} from 'vue'
import {ElNotification} from "element-plus";
import {vMaska} from 'maska'

export default defineComponent({
  name: "SchoolStudentForm",
  directives: {maska: vMaska},
  data() {
    return {
      loading: false,
      form: {
        id: null,
        school_id: null,
        full_name: null,
        class_name: null,
        class_number: null,
        phone_number: null,
        kundalik_id: null,
        region_id: null,
        district_id: null,
        board_id: null
      },
      regions: [],
      districts: [],
      boards: [],
      organizationList: [],
      baseUrl: process.env.VUE_APP_BASE_API_URL + 'api/v2/info/file/',
      rules: {
        full_name: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        school_id: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        class_name: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        class_number: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        kundalik_id: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        phone_number: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        board_id: [{required: true, message: "Majburiy maydon", trigger: "change"}],
      }
    }
  },
  computed: {
    isEditMode() {
      return !!this.form.id;
    }
  },
  methods: {
    onChangeRegion() {
      this.getDistricts();
    },
    onChangeDistrict() {
      this.getOrganizations()
    },
    getBoards() {
      this.loading = true;
      this.$http
        .get(`api/v1/my-school/boards`, { params: { cache: 'off', offset: 0, limit: 1000 } })
        .then(({ data }) => {
          this.boards = data.boards;
        })
        .catch((err) => {
          ElNotification.error({
            message: err.response?.data?.message || "Doskalar yuklanmadi!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getRegions() {
      this.$http
          .get(`api/v1/regions`)
          .then(({data}) => {
            this.regions = data.regions;
          })
          .catch((err) => {
            console.error("quarters fetch error", err);
          });
    },
    getDistricts() {
      this.$http
          .get(`api/v1/districts`, {
            params: {
              region_id: this.form.region_id,
            },
          })
          .then(({data}) => {
            this.districts = data.districts;
            if (this.form.district_id) {
              this.getOrganizations()
            }
          })
          .catch((err) => {
            console.error("quarters fetch error", err);
          });
    },
    getOrganizations() {
      this.loading = true
      this.$http
          .get(
              `api/v1/organizations?district_id=${this.form.district_id}&&organization_type=SCHOOL`
          )
          .then((res) => {
            this.organizationList = res.data?.organizations;
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getStudentById() {
      this.loading = true;
      this.$http
          .get(`/api/v1/my-school/students/${this.form.id}`)
          .then(({data}) => {
            this.form = data;
            this.form.phone_number = data.phone_number?.substring(3, data.phone_number?.length);
            if (data.region_id) {
              this.getDistricts()
            }

          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let http;
          if (this.form.id) {
            http = this.$http.put(`/api/v1/my-school/students/${this.form.id}`, {
              ...this.form,
              phone_number: '998' + this.form.phone_number.replace(/[^\d]/g, '')
            });
          } else {
            http = this.$http.post("/api/v1/my-school/students", {
              ...this.form,
              phone_number: '998' + this.form.phone_number.replace(/[^\d]/g, '')
            });
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    }
  },
  mounted() {
    this.getRegions();
    this.getBoards();
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getStudentById();
    }
  }
})
</script>

<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="18" :xl="14">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Doskani tanlang" prop="board_id">
                <el-select
                    v-model="form.board_id"
                    style="width: 100%"
                    size="large"
                    :disabled="isEditMode"
                >
                  <el-option
                      v-for="board in boards"
                      :key="board.id"
                      :value="board.id"
                      :label="board.title + ' ' + board.season + '-mavsum ' + board.year + ' yil'"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Viloyat" prop="region_id">
                <el-select
                    v-model="form.region_id"
                    style="width: 100%"
                    size="large"
                    @change="onChangeRegion"
                >
                  <el-option
                      v-for="region in regions"
                      :key="region.id"
                      :value="region.id"
                      :label="region.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Tuman" prop="district_id">
                <el-select
                    v-model="form.district_id"
                    style="width: 100%"
                    size="large"
                    @change="onChangeDistrict"
                >
                  <el-option
                      v-for="district in districts"
                      :key="district.id"
                      :value="district.id"
                      :label="district.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Maktabni tanlang" prop="school_id">
                <el-select
                    v-model="form.school_id"
                    style="width: 100%"
                    size="large"
                    @change="onChangeDistrict"
                >
                  <el-option
                      v-for="district in organizationList"
                      :key="district.id"
                      :value="district.id"
                      :label="district.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="FIO" prop="full_name">
                <el-input size="large" type="text" v-model="form.full_name"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Sinf nomi" prop="class_name">
                <el-input size="large" type="text" v-model="form.class_name"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Sinf raqami" prop="class_number">
                <el-input-number style="width: 100%" size="large" type="number" v-model="form.class_number"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Telefon nomer" prop="phone_number">
                <div class="input-wrapper">
                  <span class="prefix">+998</span>
                  <el-input size="large"
                            v-maska
                            placeholder="(__) ___-__-__"
                            data-maska="(##) ###-##-##"
                            type="text"
                            v-model="form.phone_number"/>
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Kundalik Id sini kiriting" prop="kundalik_id">
                <el-input style="width: 100%" size="large" type="text" v-model="form.kundalik_id"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                >Orqaga
                </el-button
                >
                <el-button class="custom-btn" type="primary" @click="onSubmit"
                >Saqlash
                </el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.images {
  columns: 3;

  .image-item {
    position: relative;

    :deep(el-image) {
      border: 1px solid #e4e4e4;
    }
  }
}

.input-wrapper {
  display: flex;
  box-shadow: 0 0 0 1px #dcdfe6 inset;
  border-radius: 4px;

  .prefix {
    border: 1px solid #dcdfe6;
    width: 60px;
    background-color: #f5f7fa;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
  }

  :deep(.el-input) {
    .el-input__wrapper {
      box-shadow: none;
      outline: none;
      border: 1px solid #dcdfe6;
      border-left: none;
    }
  }
}
</style>